import { gql } from '@apollo/client';

export interface ConsumerUnitQueryVariables {
  id: string;
}

export const ConsumerUnitTypename = 'ConsumerUnit';

export const CONSUMER_UNIT_QUERY = gql`
  query consumerUnit($id: ID!) {
    consumerUnit(id: $id) {
      id
      consumerUnitPowerDistributionUnitIdentifier
      consumerUnitAddressCity
      consumerUnitAddressPostalCode
      consumerUnitAddressState
      consumerUnitAddressStreet
      consumerUnitAddressDistrict
      consumerUnitAddressComplement
      powerDistributionUnitCredentialsUser
      consumerUnitModality
      consumerUnitConsumptionClass
      consumerUnitConsumptionGroupType
      powerDistributionUnitCredentialsUser
      cooperative {
        id
        cooperativeLegalName
      }
      cooperativeMember {
        id
        cooperativeMemberLegalName
      }
      powerDistributionUnit {
        id
        powerDistributionUnitLegalName
      }
    }
  }
`;
